import type { SearchApiParams } from "common/types/search";
import { defaultRegion } from "common/config";

type UrlSearchParams = {
  query?: string;
  latitude?: string;
  longitude?: string;
  types?: string;
  accessibilities?: string;
  zoom?: string;
  saved_place_id?: string;
  saved_place_user_id?: string;
  saved_place_sortby?: string;
  placesToReplaceString?: string;
  simpleLocationText?: string;
  includeGoogleFallback?: string;
  openingHoursMode?: "any" | "open_now" | "custom";
  openingHoursDay?: string;
  openingHoursTime?: string;
  section_filter?: string;
  mapper_category?: string;
};

/**
 * Pure function: converts URL search params into SearchApiParams for the API.
 * Preserves all defaults that the atom chain normally injects.
 * No side effects, no Date.now().
 */
export function buildSearchApiParams(search: UrlSearchParams): SearchApiParams {
  return {
    search: search.query || "",
    latitude: search.latitude || defaultRegion.latitude.toString(),
    longitude: search.longitude || defaultRegion.longitude.toString(),
    userlatitude: search.latitude || null,
    userlongitude: search.longitude || null,
    types: search.types || "",
    accessibilities: search.accessibilities || "",
    showVenueOptions: "All",
    addinfo: "",
    placesToReplaceString: search.placesToReplaceString || "",
    simpleLocationText: search.simpleLocationText || "",
    searchThisAreaClicked: "no",
    zoom: search.zoom || "16",
    per_page: "200",
    new_map: "1",
    tagging_mode: "off",
    progressive_update: "yes",
    userToken: "",
    saved_place_id: search.saved_place_id || "",
    saved_place_user_id: search.saved_place_user_id || "",
    saved_place_sortby: search.saved_place_sortby || "",
    unixTimestamp: null,
    includeGoogleFallback: search.includeGoogleFallback || "false",
    openingHoursMode: search.openingHoursMode,
    openingHoursDay: search.openingHoursDay,
    openingHoursTime: search.openingHoursTime,
    section_filter: search.section_filter,
    mapper_category: search.mapper_category,
  };
}
